import React, { FC } from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useTranslation } from 'react-i18next';

import useStyles from './../styles/useStyles';

interface IProps {
  open: boolean;
}

const PickerInput: FC<IProps> = ({ open }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (open) {
    return <div className={classes.closeButton}>{t('common:done')}</div>;
  }
  return <AddCircleIcon className={classes.openIcon} color="primary" />;
};

export default PickerInput;
